const publicationList = document.querySelector('.sc-publication-module');
if (publicationList) {
  // Axios get Publication list
  const axiosGetPaginatedPublicationList = async (pageNumber, button = null) => {
    const searchTerm = publicationListForm.querySelector('.publication-module__input-field')?.value || '';
    const category = (
      publicationListForm.querySelector('.dropdown__list-item [type="radio"]:checked')?.id || ''
    ).replace('all', '');
    const formDataInput = {
      action: 'getPaginatedPublicationList',
      pageNumber,
      searchTerm,
      category,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      const publicationListWrap = publicationList.querySelector('.publication-module__list');
      const publicationPagination = publicationList.querySelector('.pagination');
      const publicationResultText = publicationList.querySelector('.publication-module__header-text');

      if (publicationListWrap) {
        publicationListWrap.innerHTML = data.data.html_list;
      }

      if (publicationListWrap && publicationPagination && data.data.html_pagination) {
        publicationPagination.remove();
        publicationListWrap.insertAdjacentHTML('afterend', data.data.html_pagination);
      }

      if (publicationResultText && data.data.result_text) {
        publicationResultText.innerHTML = data.data.result_text;
      }

      publicationList.scrollIntoView();

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['searchTerm', 'pageNumber', 'category']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    } catch (err) {
      console.error(err);
    }

    if (button) {
      button.disabled = false;
    }
  };

  const publicationListForm = publicationList.querySelector('.publication-module__form');
  publicationListForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const button = publicationListForm.querySelector('.btn-publication-search');
    button.disabled = true;
    axiosGetPaginatedPublicationList(1, button);
  });

  // Pagination
  attachEvent('.publication-module .pagination .pagination__number', 'click', (ev) => {
    ev.preventDefault();
    const pageNumber = ev.target.dataset.page;
    axiosGetPaginatedPublicationList(pageNumber);
  });
}
